"use client";

import * as React from "react";

import {
  TooltipArrow as TooltipArrowPrimitive,
  TooltipContent as TooltipContentPrimitive,
  Tooltip as TooltipRootPrimitive,
  TooltipPortal as TooltipPortalPrimitive,
  TooltipProvider as TooltipProviderPrimitive,
  TooltipTrigger as TooltipTriggerPrimitive,
} from "@radix-ui/react-tooltip";

import { cn } from "@/shared/helpers/cn.helper";

const Tooltip = TooltipRootPrimitive;

const TooltipTrigger = TooltipTriggerPrimitive;

const TooltipProvider = TooltipProviderPrimitive;

interface TooltipContentProps
  extends React.ComponentPropsWithoutRef<typeof TooltipContentPrimitive> {
  showArrow?: boolean;
}

const TooltipContent = React.forwardRef<
  React.ComponentRef<typeof TooltipContentPrimitive>,
  TooltipContentProps
>(({ children, className, showArrow = true, sideOffset = 4, align = "center", ...props }, ref) => (
  <TooltipPortalPrimitive>
    <TooltipContentPrimitive
      ref={ref}
      align={align}
      className={cn("z-popover overflow-hidden whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs font-medium text-white shadow-sm", className)}
      sideOffset={sideOffset}
      {...props}
    >
      {children}
      {showArrow && (
        <TooltipArrowPrimitive
          aria-hidden
          className="fill-gray-800"
        />
      )}
    </TooltipContentPrimitive>
  </TooltipPortalPrimitive>
));
TooltipContent.displayName = TooltipContentPrimitive.displayName ?? "TooltipContent";

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
